import { ReactNode, useEffect } from 'react';
import { UserContext } from './UserContext';
import { useAuth } from '@chainlit/react-client';

interface IProps {
  children: ReactNode;
}

export const UserContextProvider = ({ children }: IProps) => {
  const { user, isAuthenticated, logout, isReady } = useAuth();

  useEffect(() => {
    if (!isReady) return;
    if (isAuthenticated) return;

    if (window.location.pathname !== '/login'
      && window.location.pathname !== '/registration'
    ) window.location.href = '/login';
  }, [ isAuthenticated, isReady ]);

  const contextValue = {
    user,
    logout
  };

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};